import { Grid, makeStyles, Table, TableBody, TableCell, TableRow } from "@material-ui/core"
import { Elements } from '@tfo/common'
import classnames from "classnames"
import { useState } from "react"
import { useIntl } from "react-intl"
import { State } from "../../../../../models/enums/State"
import { IndividualInformation } from "../../../../../models/IGroupSummary"

const { Label, Heading4 } = Elements

export type IddGroupedOrderReportListProps = {
    reports: IndividualInformation[]
    onSelectedReport: (report: IndividualInformation) => void
}

const isReceivedOrWaitingForConsent = [State.Received, State.WaitingForConsent]

export const IddGroupedOrderReportList = ({ reports, onSelectedReport }: IddGroupedOrderReportListProps) => {
    if (!reports?.length) {
        return null
    }

    const intl = useIntl()
    const [contentIndex, setContentIndex] = useState(0)

    const reportsWithDiscrepancy: IndividualInformation[] = reports.filter(o => o.reportSummary)
    const reportsWithout: IndividualInformation[] = reports.filter(o => !o.reportSummary && !isReceivedOrWaitingForConsent.includes(o.orderState))
    const reportsWaitingForIndividual: IndividualInformation[] = reports?.filter(o => isReceivedOrWaitingForConsent.includes(o.orderState))

    const content = () => {
        switch (contentIndex) {
            case 1:
                return <ReportList onSelectReport={onSelectedReport} rows={reportsWithout}></ReportList>
            case 2:
                return <ReportList onSelectReport={onSelectedReport} rows={reportsWaitingForIndividual}></ReportList>
            default:
                return <ReportList onSelectReport={onSelectedReport} rows={reportsWithDiscrepancy}></ReportList>
        }
    }

    return <>
        <Heading4 >
            {intl.formatMessage({ id: 'archived.report.label.individuals' })}
        </Heading4>
        <Grid item container justifyContent="flex-end" xs={12}>
            <Grid item>
                <div className="ReportsFiltering ReportsFilteringMenu">
                    <Label
                        className={classnames('ReportsFiltering__Item', {
                            'ReportsFiltering__Item--active': contentIndex === 0,
                        })}
                        onClick={() => setContentIndex(0)}>
                        {`${intl.formatMessage({
                            id: 'readreport.groupedOrder.notation',
                        })}(${reportsWithDiscrepancy?.length})`}
                    </Label>
                    <Label
                        className={classnames('ReportsFiltering__Item', {
                            'ReportsFiltering__Item--active': contentIndex === 1,
                        })}
                        onClick={() => setContentIndex(1)}>
                        {`${intl.formatMessage({
                            id: 'readreport.groupedOrder.noNotation',
                        })}(${reportsWithout?.length})`}
                    </Label>
                    <Label
                        className={classnames('ReportsFiltering__Item', {
                            'ReportsFiltering__Item--active': contentIndex === 2,
                        })}
                        onClick={() => setContentIndex(2)}>
                        {`${intl.formatMessage({
                            id: 'readreport.groupedOrder.waitingForIndividual',
                        })}(${reportsWaitingForIndividual?.length})`}
                    </Label>
                </div>
            </Grid>
        </Grid>
        {content()}
    </>
}

const useReportListStyles = makeStyles({
    list: {
        marginTop: '50px',
    },
    table: {
        marginTop: '3%',
        minWidth: 650,
        marginBottom: '4em'
    },
    clickableRow: {
        '&:hover': {
            cursor: 'pointer',
            background: '#e6e6e6',
        },
    },

})

const ReportList = ({ rows, onSelectReport }: { rows: IndividualInformation[], onSelectReport: (report: IndividualInformation) => void }) => {
    const intl = useIntl()
    const classes = useReportListStyles()

    return (
        <>
            <Table className={classes.table} aria-label="simple table">
                <TableBody>
                    {rows?.map((row: IndividualInformation) =>
                        row.orderState == State.Deleted ?
                            (<TableRow
                                className={row.reportSummary}
                                key={row.orderId}>
                                <TableCell component="th" scope="col">
                                    {intl.formatMessage({ id: 'readreport.label.controlperson' })} {row?.controlPerson}
                                </TableCell>
                            </TableRow>)
                            :
                            (<TableRow
                                className={row.reportSummary && classes.clickableRow}
                                key={row.orderId}
                                onClick={() => row.reportSummary && onSelectReport(row)}>
                                <TableCell component="th" scope="col">
                                    {row?.fullName}
                                </TableCell>
                                <TableCell>{row.nationalId}</TableCell>
                            </TableRow>)
                    )}
                </TableBody>
            </Table>
        </>
    )
}